import { PhotoProvider } from 'react-photo-view';

export const CustomPhotoProvider = ({ images, children }) => {
  const getImageMetadata = (index) => {
    const match = images[index];

    const categoryFiltered = images.filter((image) => image.category === match.category);
    const categoryIndex = categoryFiltered.findIndex((image) => image.image === match.image);

    return {
      ...match,
      categoryIndex,
      categoryCount: categoryFiltered.length,
    };
  };

  return (
    <PhotoProvider
      loadingElement={<span className="fs-3 color-white">loading...</span>}
      overlayRender={({ index }) => {
        const imageData = getImageMetadata(index);

        return (
          <div className="fixed-bottom text-center color-white fs-3">
            <div>{imageData.category}</div>
            <div>{`${imageData.categoryIndex + 1} of ${imageData.categoryCount}`}</div>
          </div>
        );
      }}
    >
      {children}
    </PhotoProvider>
  );
};
